import React, { useContext, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import ErrorBoundary from "./components/errorBoundary";
import { AppContext } from "./context/AppContext";
import MainRoutes from "./routes/routes";
const App: React.FC = () => {
	const { checkUserLog, user } = useContext(AppContext);

	useEffect(() => {
		checkUserLog();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.isUserLoggedIn]);

	return (
		<ErrorBoundary>
			<MainRoutes />
			<ToastContainer
				closeOnClick
				position={toast.POSITION.BOTTOM_RIGHT}
				bodyStyle={{ color: "white" }}
			/>
		</ErrorBoundary>
	);
};

export default App;
